var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 58,
    viewBox: "0 0 60 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "kdf8kxi9qa",
    d: "M0 0h58v58H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "9pdcr61c9c",
    d: "M.526 58h58V0h-58z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.92)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.526)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jv6rqos0ub",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kdf8kxi9qa"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.375 37.156c0-1.878 1.434-3.405 3.264-3.588a29.197 29.197 0 0 0 0-9.135c-1.83-.184-3.264-1.71-3.264-3.59 0-1.18.572-2.217 1.446-2.88a28.973 28.973 0 0 0-3.96-6.796 3.625 3.625 0 0 1-5.028-5.028 28.964 28.964 0 0 0-6.797-3.96 3.608 3.608 0 0 1-2.88 1.446c-1.878 0-3.405-1.434-3.588-3.264A29.197 29.197 0 0 0 29 .001c-1.555 0-3.08.125-4.568.36-.183 1.83-1.71 3.264-3.588 3.264a3.607 3.607 0 0 1-2.88-1.446 28.956 28.956 0 0 0-6.796 3.96 3.625 3.625 0 0 1-5.028 5.028 28.958 28.958 0 0 0-3.96 6.797 3.607 3.607 0 0 1 1.445 2.88c0 1.878-1.434 3.405-3.264 3.588A29.197 29.197 0 0 0 0 29c0 1.555.125 3.08.361 4.568 1.83.183 3.264 1.71 3.264 3.588 0 1.18-.573 2.218-1.445 2.88a28.942 28.942 0 0 0 3.96 6.796 3.625 3.625 0 0 1 5.028 5.029 28.968 28.968 0 0 0 6.796 3.96 3.607 3.607 0 0 1 2.88-1.446c1.878 0 3.405 1.434 3.588 3.264 1.489.235 3.013.361 4.568.361 1.554 0 3.08-.126 4.568-.361.183-1.83 1.71-3.264 3.588-3.264 1.18 0 2.218.573 2.88 1.445a28.976 28.976 0 0 0 6.797-3.96 3.625 3.625 0 0 1 5.028-5.029 28.957 28.957 0 0 0 3.96-6.795 3.606 3.606 0 0 1-1.446-2.88",
    fill: "#C1BDBA",
    mask: "url(#jv6rqos0ub)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.826 29c0 11.532-9.348 20.88-20.88 20.88-11.532 0-20.88-9.348-20.88-20.88 0-11.532 9.348-20.88 20.88-20.88 11.532 0 20.88 9.348 20.88 20.88",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.926 29.29c0 10.09-8.18 18.27-18.27 18.27s-18.27-8.18-18.27-18.27 8.18-18.27 18.27-18.27 18.27 8.18 18.27 18.27",
    fill: "#AED8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.946 11.683c-9.549 0-17.318 7.768-17.318 17.317 0 9.548 7.77 17.317 17.318 17.317 9.549 0 17.317-7.769 17.317-17.317 0-9.549-7.768-17.317-17.317-17.317m0 36.457c-10.554 0-19.14-8.586-19.14-19.14s8.586-19.14 19.14-19.14 19.14 8.586 19.14 19.14-8.586 19.14-19.14 19.14",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "g3rdebvlxd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9pdcr61c9c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    mask: "url(#g3rdebvlxd)",
    d: "M15.606 8.12h1.74V6.38h-1.74zM28.366 4.64h1.74V2.9h-1.74zM28.366 55.1h1.74v-1.74h-1.74zM41.126 8.12h1.74V6.38h-1.74zM15.606 51.62h1.74v-1.74h-1.74zM41.126 51.62h1.74v-1.74h-1.74zM49.826 17.4h1.74v-1.74h-1.74zM49.826 42.34h1.74V40.6h-1.74zM6.326 42.34h1.74V40.6h-1.74zM6.326 17.4h1.74v-1.74h-1.74zM53.306 30.16h1.74v-1.74h-1.74zM2.846 30.16h1.74v-1.74h-1.74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.539 30.16-6.293 3.609v1.805a2.702 2.702 0 0 0 2.697 2.706h12.586a2.702 2.702 0 0 0 2.697-2.706v-1.805l-6.293-3.609H26.54z",
    fill: "#5DB1BD",
    mask: "url(#g3rdebvlxd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.22 38.86H22.672c-1.978 0-3.586-1.628-3.586-3.629v-2.34L25.812 29l.89 1.575-5.823 3.368v1.288c0 1.001.804 1.815 1.793 1.815H35.22c.99 0 1.793-.814 1.793-1.815v-1.288l-5.822-3.368L32.08 29l6.726 3.89v2.341c0 2-1.608 3.629-3.586 3.629",
    fill: "#333",
    mask: "url(#g3rdebvlxd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.586 24.312c0-1.837-.87-4.592-4.35-4.592-3.48 0-4.35 2.755-4.35 4.592v.918c0 2.755 1.74 5.51 4.35 5.51 2.61 0 4.35-2.755 4.35-5.51v-.918z",
    fill: "#FFF",
    mask: "url(#g3rdebvlxd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.656 20.383c-3.316 0-3.673 2.55-3.673 3.645v.912c0 2.192 1.404 4.557 3.673 4.557s3.673-2.365 3.673-4.557v-.912c0-1.095-.358-3.645-3.673-3.645m0 10.937c-3.404 0-5.51-3.311-5.51-6.38v-.912c0-2.522 1.443-5.468 5.51-5.468s5.51 2.946 5.51 5.468v.912c0 3.069-2.107 6.38-5.51 6.38",
    fill: "#333",
    mask: "url(#g3rdebvlxd)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/Account.bf4451bb7083909ce500f2e876ba205c.svg";
export { ForwardRef as ReactComponent };